import(/* webpackMode: "eager", webpackExports: ["LayoutHeader"] */ "/vercel/path0/src/app/(products)/product/universal-series/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/footer/index.tsx");
